
const SvgComponent = () => {
  const w = 31
  const h = 31
  return (
    <svg xmlns="http://www.w3.org/2000/svg" data-name="back arrow" width={w} height={h} viewBox="0 0 31 31">
      <circle data-name="Ellipse 6" cx="15.5" cy="15.5" r="15.5" fill="#f7f7f7" />
      <path data-name="Path 603" d="M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z" />
    </svg>
  )
}

export default SvgComponent
